import React, { useState, useEffect } from "react";
import { addDays, parseISO } from "date-fns";
import {
  MDBSideNavItem,
  MDBSideNavLink,
  MDBSideNavCollapse,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBSelect,
} from "mdb-react-ui-kit";

const predefinedDateRanges = [
  { text: "All Future", value: "Future" },
  { text: "Today", value: "Today" },
  { text: "Next 3 Days", value: "Next 3 Days" },
  { text: "Next 5 Days", value: "Next 5 Days" },
  { text: "Next 7 Days", value: "Next 7 Days" },
  { text: "Custom", value: "Custom" },
];

function MeetingTimeFilter({
  dateFilter,
  setDateFilter,
  setDateRange,
  dateCollapse,
  setDateCollapse,
}) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (startDate && endDate) {
      setDateRange({
        start: parseISO(startDate),
        end: parseISO(endDate),
      });
    }
  }, [startDate, endDate, setDateRange]);

  useEffect(() => {
    if (dateFilter === "Future") {
      setStartDate(""); // Clear start date
      setEndDate(""); // Clear end date
      setDateRange(null); // Reset date range for "All Future"
    }
  }, [dateFilter, setDateRange]);

  const handleDateFilterChange = (value) => {
    setDateFilter(value);

    const today = new Date();

    switch (value) {
      case predefinedDateRanges[0].value: // "All Future"
        setDateRange(null);
        break;
      case predefinedDateRanges[1].value: // "Today"
        setDateRange({ start: today, end: today });
        break;
      case predefinedDateRanges[2].value: // "Next 3 Days"
        setDateRange({ start: today, end: addDays(today, 3) });
        break;
      case predefinedDateRanges[3].value: // "Next 5 Days"
        setDateRange({ start: today, end: addDays(today, 5) });
        break;
      case predefinedDateRanges[4].value: // "Next 7 Days"
        setDateRange({ start: today, end: addDays(today, 7) });
        break;
      case predefinedDateRanges[5].value: // "Custom"
        setDateRange(null); // Clear date range for "Custom"
        break;
      default:
        setDateRange(null);
    }
  };

  return (
    <MDBSideNavItem>
      <MDBSideNavLink
        className="accordion-button"
        icon="angle-down"
        shouldBeExpanded={dateCollapse}
        onClick={() => setDateCollapse(!dateCollapse)}
      >
        Timeframe
      </MDBSideNavLink>
      <MDBSideNavCollapse open={dateCollapse}>
        <li className="p-3">
          <MDBSelect
            data={predefinedDateRanges}
            value={dateFilter}
            label="Select Date Range"
            onChange={(selected) => handleDateFilterChange(selected.value)}
            visibleOptions={6} // Want all options shown
          />
          {dateFilter === "Custom" && ( // Show `.date-range` only when "Custom" is selected
            <div className="date-range mt-3">
              <MDBRow className="g-1">
                <MDBCol size="6">
                  <MDBInput
                    className="mb-2"
                    type="date"
                    value={startDate}
                    label="From Date"
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </MDBCol>
                <MDBCol size="6">
                  <MDBInput
                    className="mb-2"
                    type="date"
                    value={endDate}
                    label="To Date"
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </MDBCol>
              </MDBRow>
            </div>
          )}
        </li>
      </MDBSideNavCollapse>
    </MDBSideNavItem>
  );
}

export default MeetingTimeFilter;
